import { render, staticRenderFns } from "./InfoProjects.vue?vue&type=template&id=dba6119e&"
import script from "./InfoProjects.vue?vue&type=script&lang=js&"
export * from "./InfoProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports